import type { FundingApplicationSchemas } from "api-types";
import { axiosClient } from "auth-sdk";

import {
  FUNDING_APPLICATION_CONFIGURATION_API,
  FUNDING_APPLICATION_IS_SUBMITTABLE_API,
} from "../../components/constants";

export const getFundingApplicationStagesQueryOptions = (customerDomain: string) => {
  const url = FUNDING_APPLICATION_CONFIGURATION_API.replace(":customerSlug", customerDomain);

  return {
    queryKey: [url],
    queryFn: () => axiosClient.get<FundingApplicationSchemas.CustomerFundingApplicationStagesScreen | null>(url),
    select: ({
      data,
    }: {
      data: FundingApplicationSchemas.CustomerFundingApplicationStagesScreen | null;
    }): FundingApplicationSchemas.CustomerFundingApplicationStagesScreen | null => data,
    refetchOnMount: true,
  };
};

export const getIsFundingApplicationSubmittableQueryOptions = (customerDomain: string, applicationId: number) => {
  const url = FUNDING_APPLICATION_IS_SUBMITTABLE_API.replace(":customerSlug", customerDomain).replace(
    ":applicationId",
    applicationId.toString()
  );
  return {
    queryKey: [url],
    queryFn: () => axiosClient.get<boolean>(url),
    select: ({ data }: { data: boolean }): boolean => data,
  };
};
